import {
  transactionActions,
  useTransactionSelector,
} from 'features/Invoice/screens/ListTransactions/slice'
import CustomDataTable from 'general/components/CustomDataTable'
import { useAppDispatch, useAppSelector } from 'hooks/useRedux'
import _ from 'lodash'
import { useEffect } from 'react'
import { shallowEqual } from 'react-redux'

export const InvoiceTable = (props) => {
  const {
    dataSource,
    isLoading,
    defaultColumns,
    filterParams,
    setFilterParams,
  } = props
  const { selectedInvoices } = useAppSelector(
    (state) => state.invoice,
    shallowEqual,
  )

  const { clearSelectedRows, selectedRows } = useTransactionSelector()

  const dispatch = useAppDispatch()

  return (
    <>
      <CustomDataTable
        columns={defaultColumns}
        dataSource={dataSource?.tableData}
        isLoading={isLoading}
        isClickable
        // handleDoubleClickRow={(row) => viewPdfInvoice(row)}
        pagination={{
          total: dataSource?.total,
          rowsPerPage: filterParams.limit,
          currentPage: filterParams.page,
          onChangePage: (page) => {
            setFilterParams({
              page,
            })
          },
          onChangeRowsPerPage: (limit) => {
            setFilterParams({
              limit,
              page: 1,
            })
          },
        }}
        isSelectable
        selectedRows={{
          clearSelectedRows,
          selectableRowSelected: (row) => _.includes(selectedRows, row),
          handleSelectedRows: (selected) =>
            dispatch(transactionActions.setSelectedRows(selected.selectedRows)),
        }}
      />
    </>
  )
}
